import React, { useState } from 'react';
import {
  FaHome,
  FaServicestack,
  FaInfoCircle,
  FaEnvelope,
  FaThLarge,
  FaBars,
  FaTimes
} from 'react-icons/fa';

const LayoutHeader = ({ navigate }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const navItems = [
    { label: 'Inicio', icon: <FaHome />, path: 'home' },
    { label: 'Servicios', icon: <FaServicestack />, path: 'services' },
    { label: 'Plataformas', icon: <FaThLarge />, path: 'platforms' },
    { label: 'Nosotros', icon: <FaInfoCircle />, path: 'about' },
    { label: 'Contacto', icon: <FaEnvelope />, path: 'contact' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">

          {/* Logo */}
          <div
            className="flex items-center cursor-pointer"
            onClick={() => navigate('home')}
          >
            <img
              src="/img/logos/logo.jpg"
              alt="Logo Steps Colombia"
              className="28h w-28 rounded-full object-cover mr-2"
            />
          </div>

          {/* Menú Desktop */}
          <nav className="hidden md:flex space-x-6">
            {navItems.map(({ label, icon, path }) => (
              <button
                key={path}
                className="flex items-center text-gray-700 hover:text-[#00bff2] font-medium transition-colors"
                onClick={() => navigate(path)}
              >
                <span className="mr-1">{icon}</span> {label}
              </button>
            ))}
          </nav>

          {/* Botón de menú móvil */}
          <button className="md:hidden text-[#007dc6]" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
          </button>
        </div>

        {/* Menú móvil desplegable */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 space-y-4">
            {navItems.map(({ label, icon, path }) => (
              <button
                key={path}
                className="w-full flex items-center text-left text-gray-700 hover:text-[#00bff2] font-medium transition-colors"
                onClick={() => {
                  navigate(path);
                  closeMobileMenu();
                }}
              >
                <span className="mr-2">{icon}</span> {label}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default LayoutHeader;



